import { render, staticRenderFns } from "./InvestDeathAndDisabilityBenefit.vue?vue&type=template&id=59dc5200&scoped=true"
import script from "./InvestDeathAndDisabilityBenefit.vue?vue&type=script&lang=js"
export * from "./InvestDeathAndDisabilityBenefit.vue?vue&type=script&lang=js"
import style0 from "./InvestDeathAndDisabilityBenefit.vue?vue&type=style&index=0&id=59dc5200&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59dc5200",
  null
  
)

export default component.exports